import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecentActivity = ({ projects = [] }) => {
  const recentJobs = [...projects]
    ?.filter(Boolean)
    ?.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at))
    ?.slice(0, 5)
    ?.map((p) => ({
      id: p?.id,
      name: p?.name || 'Projeto',
      printer: p?.printer ? `${p?.printer?.brand || ''} ${p?.printer?.model || p?.printer?.name || ''}`.trim() : '—',
      status: p?.status || 'draft',
      durationHours: p?.estimated_duration_hours || 0,
      costFinal: p?.final_price || 0,
      image: p?.image_url || null,
      startTime: p?.created_at
    }));


  const getStatusConfig = (status) => {
    const configs = {
      completed: {
        color: 'text-success',
        bgColor: 'bg-success/10',
        icon: 'CheckCircle',
        label: 'Concluído'
      },
      printing: {
        color: 'text-primary',
        bgColor: 'bg-primary/10',
        icon: 'Play',
        label: 'Imprimindo'
      },
      queued: {
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        icon: 'Clock',
        label: 'Na Fila'
      }
    };
    return configs?.[status] || configs?.queued;
  };

  const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date?.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatCurrency = (value) => {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value || 0));
    } catch {
      return `R$ ${(Number(value || 0)).toFixed(2)}`;
    }
  };

  const formatDuration = (hours) => {
    const totalMinutes = Math.round(Number(hours || 0) * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${h}h ${m}m`;
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Atividade Recente</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          Ver Todos
        </button>
      </div>
      <div className="space-y-4">
        {recentJobs?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="History" size={32} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-muted-foreground">Nenhuma atividade recente no período selecionado</p>
          </div>
        ) : recentJobs?.map((job) => {
          const statusConfig = getStatusConfig(job?.status);

          return (
            <div
              key={job?.id}
              className="flex items-center space-x-4 p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors cursor-pointer">

              {/* Job Image */}
              {job?.image ? (
                <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                  <Image
                    src={job?.image}
                    alt={job?.name}
                    className="w-full h-full object-cover" />
                </div>
              ) : (
                <div className="w-12 h-12 rounded-lg border border-border bg-muted flex items-center justify-center flex-shrink-0">
                  <Icon name="Package" size={18} className="text-muted-foreground" />
                </div>
              )}
              {/* Job Details */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-medium text-foreground truncate">{job?.name}</h3>
                  <span className="text-sm font-medium text-foreground">{formatCurrency(job?.costFinal)}</span>
                </div>
                
                <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                  <span className="flex items-center space-x-1">
                    <Icon name="Printer" size={14} />
                    <span>{job?.printer}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <Icon name="Clock" size={14} />
                    <span>{formatDuration(job?.durationHours)}</span>
                  </span>
                </div>
              </div>
              {/* Status Badge */}
              <div className={`flex items-center space-x-2 px-3 py-1 rounded-full ${statusConfig?.bgColor}`}>
                <Icon name={statusConfig?.icon} size={14} className={statusConfig?.color} />
                <span className={`text-xs font-medium ${statusConfig?.color}`}>
                  {statusConfig?.label}
                </span>
              </div>
            </div>);
        })}
      </div>
    </div>);

};

export default RecentActivity;